<script setup lang="ts">
  const isIOSDevice = ref<boolean>(false);

  onMounted(() => {
    isIOSDevice.value = document.documentElement.classList.contains('apple-device');
  });

  function closeBanner() {
    stores.user.setIsPwaBannerEnabled(false);
  }

  async function openGuide() {
    navigateTo({ name: ERouteName.HELP_CENTER, hash: '#installation-instruction' });
    closeBanner();
  }
</script>

<template>
  <div
    class="fixed top-0 z-[1] w-full flex items-center justify-center gap-1.5 bg-[#0080ff] [@media(orientation:landscape)_and_(pointer:coarse)]:hidden h-[var(--pwa-banner-height)]"
    @click.stop="openGuide"
  >
    <component :is="isIOSDevice ? 'SvgoApple' : 'SvgoAndroid'" class="size-5" />

    <span class="text-white font-semibold text-[15px] leading-[120%] font-barlow">Download MaxDuel App</span>

    <div
      class="absolute top-0 right-0 cursor-pointer w-11 h-11 flex items-center justify-center"
      @click.stop="closeBanner"
    >
      <Icon class="size-6 absolute text-white top-2.5 right-2.5 cursor-pointer rotate-45" name="i-lucide:plus" />
    </div>
  </div>
</template>
